/**
 * Nitrofurantoin drug configuration
 * Indication-agnostic product facts
 */

import type { Drug } from "../types";

export const nitrofurantoinDrug: Drug = {
  id: "nitrofurantoin",
  name: "Nitrofurantoin",
  drugClass: "nitrofuran antibiotic",
  defaultFoodTiming: "Take with food or milk",
  formulations: [
    {
      id: "nitro-100-mr-cap",
      type: "capsule_mr",
      strength: 100,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: false,
      crushNote: "Modified release — do not crush",
      tasteNote: "Yellow capsule, tasteless",
      storageNote: "Store at room temperature",
      prescribedItemId: "a182a199-4a8e-4662-a8a8-6c9d737bfe9f",
    },
    {
      id: "nitro-50-ir-tab",
      type: "tablet_ir",
      strength: 50,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: true,
      tasteNote: "Bitter taste — swallow whole if possible",
      storageNote: "Store at room temperature",
      prescribedItemId: "6d4155d7-a103-47d2-949d-5d1548fe59e4",
    },
    {
      id: "nitro-50-ir-cap",
      type: "capsule_ir",
      strength: 50,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: false,
      crushNote: "Yellow capsule — do not crush",
      tasteNote: "Tasteless if swallowed whole",
      storageNote: "Store at room temperature",
      prescribedItemId: "2a050213-f4cf-4060-8923-f09fa0aab9b6",
    },
  ],
};
